import { Environment, generateDeviceId } from '@1debit/device-intelligence';

export const deviceIntelligenceEnvironment = (
  deployEnvironment: string
): Environment => {
  return deployEnvironment === 'development'
    ? Environment.Development
    : deployEnvironment === 'production'
      ? Environment.Production
      : Environment.NonProduction;
};

export const buildDeviceIntelligenceHeaders = (
  deployEnvironment: string,
  deviceIntelligence?: string
): Record<string, string> => {
  const deviceId = generateDeviceId({
    env: deviceIntelligenceEnvironment(deployEnvironment),
  });

  return {
    ...(deviceId && { 'Chime-Device-UUID': deviceId }),
    ...(deviceIntelligence && {
      'Chime-Device-Intelligence': deviceIntelligence,
    }),
  };
};
